import React, { useState, useEffect, useRef } from 'react';
import { VAPI_CONFIG } from '../config';
import Vapi from '@vapi-ai/web';

export const AlmoosaPage = () => {
  const [isVapiActive, setIsVapiActive] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRinging, setIsRinging] = useState(false);
  const [vapi, setVapi] = useState(null);
  const ringtoneRef = useRef(null);
  const vapiRef = useRef(null);

  const ASSISTANT_ID = 'cd9641ab-7102-4761-aa30-2ff5065a048f';

  useEffect(() => {
    // Initialize ringtone audio
    const audio = new Audio('/ringtone.mp3');
    audio.loop = true;
    ringtoneRef.current = audio;

    // Initialize Vapi
    const initializeVapi = async () => {
      try {
        if (!VAPI_CONFIG || !VAPI_CONFIG.PUBLIC_KEY) {
          console.error('Vapi PUBLIC_KEY is not configured.');
          return;
        }
        const vapiInstance = new Vapi(VAPI_CONFIG.PUBLIC_KEY);
        vapiRef.current = vapiInstance;
        setVapi(vapiInstance);

        vapiInstance.on('call-start', () => {
          setIsVapiActive(true);
          setIsSpeaking(false);
          setIsListening(true);
          setIsLoading(false);
          // Stop ringing when call starts
          if (ringtoneRef.current) {
            ringtoneRef.current.pause();
            ringtoneRef.current.currentTime = 0;
            setIsRinging(false);
          }
        });
        vapiInstance.on('call-end', () => {
          setIsVapiActive(false);
          setIsSpeaking(false);
          setIsListening(false);
          setIsLoading(false);
          setIsRinging(false);
          // Stop ringing if call ends
          if (ringtoneRef.current) {
            ringtoneRef.current.pause();
            ringtoneRef.current.currentTime = 0;
          }
        });
        vapiInstance.on('error', (e) => {
          console.error('Vapi error:', e);
          setIsVapiActive(false);
          setIsSpeaking(false);
          setIsListening(false);
          setIsLoading(false);
          setIsRinging(false);
          // Stop ringing on error
          if (ringtoneRef.current) {
            ringtoneRef.current.pause();
            ringtoneRef.current.currentTime = 0;
          }
        });
        vapiInstance.on('speech-start', () => {
          setIsSpeaking(true);
          setIsListening(false);
          // Stop ringing when NOURA starts speaking
          if (ringtoneRef.current) {
            ringtoneRef.current.pause();
            ringtoneRef.current.currentTime = 0;
            setIsRinging(false);
          }
        });
        vapiInstance.on('speech-end', () => {
          setIsSpeaking(false);
          setIsListening(true);
        });

      } catch (error) {
        console.error('Failed to initialize Vapi:', error);
      }
    };
    initializeVapi();
    return () => {
      vapiRef.current?.stop();
      if (ringtoneRef.current) {
        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
      }
    };
  }, []); // Remove dependency array to run only once

  const startVapiCall = async () => {
    if (!vapi) {
      console.error('Vapi not initialized or PUBLIC_KEY missing.');
      return;
    }
    try {
      setIsLoading(true);
      setIsRinging(true);
      
      // Start ringing sound
      if (ringtoneRef.current) {
        ringtoneRef.current.play().catch(e => console.log('Could not play ringtone:', e));
      }

      await vapi.start(ASSISTANT_ID);
    } catch (error) {
      console.error('Failed to start Vapi:', error);
      setIsVapiActive(false);
      setIsLoading(false);
      setIsRinging(false);
      // Stop ringing on error
      if (ringtoneRef.current) {
        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
      }
    }
  };

  return (
    <div className="w-screen h-screen bg-[#1E1E2E] overflow-hidden relative">
      {/* Page content */}
              <div className="absolute inset-0 z-10 flex flex-col items-center justify-center">
          <div className="text-center text-white mb-8">
            <img 
              src="/almoosa.png" 
              alt="Almoosa Hospital" 
              className="w-auto h-32 mb-4 mx-auto"
            />
          </div>
          
          {/* Vapi Call Button - Centered */}
          <div className="flex justify-center mt-4">
          <button 
            className={`example-button${(isSpeaking || isListening || isRinging) ? ' loading' : ''} ${isVapiActive ? 'active' : ''}`}
            onClick={startVapiCall}
            disabled={isVapiActive || isLoading || isRinging}
          >
            {(isSpeaking || isListening) && (
              <span className="speaker-label">
                {isSpeaking ? 'Noura' : 'You'}
              </span>
            )}
            {isLoading ? (
              <span className="spinner"></span>
            ) : isRinging ? (
              <span className="ringing-text">Ringing...</span>
            ) : isSpeaking
              ? 'Speaking...'
              : isListening
                ? 'Listening...'
                : "Call"}
          </button>
        </div>
      </div>
    </div>
  );
};
